import { Loader2 } from 'lucide-react';

export function Splash({ label = 'Lade …' }: { label?: string }) {
  return (
    <div className="splash">
      <Loader2 className="spin" aria-hidden="true" />
      <span role="status">{label}</span>
    </div>
  );
}
